import { RouterProvider } from 'react-router';

import { HeaderProvider } from '@/hooks/header/HeaderContext';
import { useAllFeatureFlags } from '@/hooks/useFeatureFlag';
import { NotificationProvider } from '@/providers/Notification';
import { ThemeProvider } from '@/providers/Theme';
import { UserProvider } from '@/providers/User';
import getRouter from '@/router/Router';

function App() {
  const flags = useAllFeatureFlags();
  const router = getRouter(flags);

  return (
    <UserProvider>
      <ThemeProvider>
        <NotificationProvider>
          <HeaderProvider>
            <RouterProvider router={router} />
          </HeaderProvider>
        </NotificationProvider>
      </ThemeProvider>
    </UserProvider>
  );
}

export default App;
